import { View } from 'foundations-components/components/View';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorScrollingBodyContainer = props => {
  const {
    children,
    'data-test-id': dataTestId
  } = props;
  return /*#__PURE__*/_jsx(ScrollContainer, {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(View, {
      minBlockSize: "100%",
      paddingInline: "400",
      paddingBlockStart: "0",
      paddingBlockEnd: "400",
      children: children
    })
  });
};
export default EditorScrollingBodyContainer;